// Mirrors the backend length rule for applicationText:
//   trim(preg_replace('/\s+/u', ' ', preg_replace('/(?:\x{00A0}|&nbsp;)+/u', ' ', strip_tags($value))))
// then mb_strlen (code points). Tags are removed, runs of nbsp / '&nbsp;' / any whitespace
// collapse to a single space, outer whitespace is trimmed. Keep in sync with the backend.
const PHP_TRIM = /^[ \t\n\r\0\x0B]+|[ \t\n\r\0\x0B]+$/g

export function applicationTextContent(html: string | null | undefined) {
    const text = String(html ?? '')
        .replace(/<[^>]*>/g, '')
        .replace(/(?:\u00A0|&nbsp;)+/gu, ' ')
        .replace(/\s+/gu, ' ')
        .replace(PHP_TRIM, '')
    return { text, length: Array.from(text).length, hasContent: text !== '' }
}

export function applicationTextToEditorHtml(text: string) {
    if (!text) return ''
    if (
        /<\/(p|div|span|h[1-6]|strong|b|em|i|u|s|del|ul|ol|li|a|blockquote|code|pre|table|tr)\s*>|<(br|hr|img)\b/i.test(
            text
        )
    )
        return text
    return text
        .split(/\r\n?|\n/)
        .map((line) => `<p>${line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') || '<br>'}</p>`)
        .join('')
}
